import { Box, styled } from '@mui/material';

const ErrorWrapper = styled(Box)`
  width: max-content;

  display: flex;
  align-items: center;
  gap: 5px;
`;

export default ErrorWrapper;
